const productCards = document.querySelectorAll('.product-card');

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle('is-active', entry.isIntersecting);
    });
  },
  {
    threshold: 1,
  },
);

productCards.forEach((card) => {
  if (windowWidth() <= breakpointSm) observer.observe(card);
});
